<template>
    <div class="login page-container">
        <div class="md md-dialog-fullscreen md-transition-in md-dialog">
            <div class="go1-user-login">
                <page-header>
                    <h3 slot="title" class="title">
                        {{title}}
                    </h3>
                    <h6 slot="subtitle" class="subtitle">
                        Access thousands of learning items from top content providers.
                    </h6>
                    <div slot="caption" class="caption" v-if="showForm || failedAttempt">
                        <h4 class="caption-text">
                            Don't have an account?
                            <router-link to="/register">
                                <a>Sign up</a>
                            </router-link>
                        </h4>
                    </div>
                </page-header>

                <form-error v-if="failedAttempt" :error="error"></form-error>

                <form role="form" class="loginForm" v-if="showForm || failedAttempt">
                    <text-input
                        label="Email"
                        type="email"
                        name="email"
                        autocomplete="email"
                        v-model="username"
                        @enterpressed="login()"
                    />
                    <br>

                    <text-input
                        label="Password"
                        type="password"
                        name="password"
                        autocomplete="password"
                        v-model="password"
                        @enterpressed="login()"
                    />

                    <div class="forgotten-password-link">
                        <a :href="forgottenPassword" target="_blank">
                            Forgot your password?
                        </a>
                    </div>
                    <button-submitter
                        @button-clicked="login"
                        :attemptingSubmit="attemptingSubmit"
                        :formSubmit="false"
                        :submitEnabled="submitEnabled"
                        :clickText="clickText"
                        attemptText="Logging in..."
                    />

                </form>

                <div class="text-center border-top mt-5 pt-5 pb-5" v-if="showSSO && (showForm || failedAttempt)">
                    <h4>
                        If you have previously connected your Go1 portal to Microsoft Azure,
                        <a :href="ssoUrl">click here</a>
                    </h4>
                </div>

                <div class="text-center my-5" v-if="!showForm && !failedAttempt">
                    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                    <h4>Attempting to log in</h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthService from '../../services/AuthService'
import ButtonSubmitter from '../../components/Generic/ButtonSubmitter'
import FormError from '../../components/Generic/FormError'
import PageHeader from "../Generic/PageHeader";
import TextInput from '../Generic/TextInput';

export default {
  name: 'Login',

  data () {
    return {
      username: "",
      password: "",
      failedAttempt: false,
      attemptingSubmit: false,
      error: {},
      showForm: !window.authConfig.one_time_token,
      showSSO: window.authConfig.identity_group,
    }
  },

  computed: {
      clickText() {
          return `Log in and connect`
      },

      //oAuth client name
      clientName() {
          return this.$store.state.client_name;
      },

      title() {
          if (window.authConfig.referrer) {
              return `Log in to Go1 with your ${window.authConfig.referrer} credentials`;
          }
          return `Log in to Go1 and authorize ${this.clientName} to use your account`;
      },

      //validate input is ok
      validInput () {
          return this.username !== "" && this.password !== "";
      },

      //boolean to check if the input is valid and the user isn't already trying to submit
      submitEnabled () {
        return this.validInput && !this.attemptingSubmit;
      },

      //this allows for the link to open a new window and redirect the user to the Go1 Forgotten password flow
      forgottenPassword () {
        // https://website.dev.go1.cloud/password/reset
        // https://website.qa.go1.cloud/password/reset
        // https://www.go1.com/password/reset
        const portal_url = this.$store.state.portal_url || window.authConfig.portal_root_domain === 'mygo1.com'
            ? 'https://app.go1.com'
            : 'https://app.qa.go1.cloud';
        return `${portal_url}/password/reset?login_url=${encodeURIComponent(location.href)}`;
      },

      ssoUrl () {
          return AuthService.getAuthorizeIdpUrl('azure', window.authConfig.identity_group, encodeURIComponent(window.location.href.replace(/#\/$/g, '')));
      },
  },

  components: {
      'page-header': PageHeader,
      'button-submitter': ButtonSubmitter,
      'form-error': FormError,
      'text-input': TextInput
  },

  methods: {
      login (credentials) {
          // return early if submit isn't enabled
          if (!this.submitEnabled && !credentials) {
            return;
          }
          this.attemptingSubmit = true;
          AuthService.login(credentials ? credentials : {
              username: this.username,
              password: this.password
          }).then((data) => {
              // user is logged in, route to the portals listing page
              if (window.authConfig.scheme === 'saml') {
                  if (window.authConfig.redirect_uri) {
                      window.location = window.authConfig.redirect_uri;
                  } else {
                      window.history.go();
                  }
              } else if (window.authConfig.portal) {
                  let selectedPortal = null;
                  for (let i=0; data.accounts.length; i++) {
                      if (data.accounts[i].instance_name === window.authConfig.portal) {
                          selectedPortal = data.accounts[i];
                          break;
                      }
                  }
                  if (selectedPortal !== null) {
                      this.$router.push({
                          name: 'portal_auth',
                          params: {
                              portal_id: selectedPortal.instance.id,
                              portal_name: selectedPortal.instance.configuration.site_name,
                              portal_url: window.authConfig.portal
                          }
                      });
                  }
              } else if (data.accounts.length === 1) {
                  this.$router.push({
                      name: 'portal_auth',
                      params: {
                          portal_id: data.accounts[0].instance.id,
                          portal_name: data.accounts[0].instance.configuration.site_name,
                          portal_url: data.accounts[0].instance.title
                      }
                  });
              } else {
                  this.$router.push({name: 'portals'});
              }
          }).catch( err => {
              this.failedAttempt = true;
              this.attemptingSubmit = false;
              this.error = err.response.data;
          })
      }
  },

  beforeMount: function () {
      if (window.authConfig.one_time_token) {
          return this.login({token: window.authConfig.one_time_token});
      }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auth/Login.vue